import { render, staticRenderFns } from "./TransferForecastReport.vue?vue&type=template&id=349c6d74"
import script from "./TransferForecastReport.vue?vue&type=script&lang=js"
export * from "./TransferForecastReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports